import { FC, useEffect, useState } from "react";
import Router from "./routes/Router";
import LocalStorageLanguageRepository from "details/storage/localStorage/repositories/localStorageLanguageRepository/LocalStorageLanguageRepository";
import internationalizationService from "./shared/services/internationalizationService";
import AppZustandProvider from "./shared/contexts/AppContextProvider";
import { ServiceContainerProvider } from "@/core/di";
import { Toaster } from "@/components/ui/sonner";
import { getDeviceFingerprint, getIpAddress } from "@/lib/utils";
import { BrandThemeProvider } from "./shared/contexts/BrandThemeContext";

internationalizationService.init(new LocalStorageLanguageRepository());

const App: FC = () => {
  const [ip, setIp] = useState<string | null>(localStorage.getItem("publicIp"));
  const [fingerprint, setFingerprint] = useState<string | null>(
    localStorage.getItem("fingerprint"),
  );

  useEffect(() => {
    // Fetch IP si nécessaire
    if (!ip) {
      getIpAddress().then((publicIp) => {
        localStorage.setItem("publicIp", publicIp);
        setIp(publicIp);
      });
    }

    // Fetch fingerprint si nécessaire
    if (!fingerprint) {
      getDeviceFingerprint().then((fp) => {
        localStorage.setItem("fingerprint", fp);
        setFingerprint(fp);
      });
    }
  }, []); // exécution une seule fois au montage

  return (
    <ServiceContainerProvider>
      <AppZustandProvider>
        <BrandThemeProvider>
          <Router />
          <Toaster closeButton />
        </BrandThemeProvider>
      </AppZustandProvider>
    </ServiceContainerProvider>
  );
};

export default App;
